module.exports = __webpack_public_path__ + "img/faq2.42ec14d8.webp";